export const VISUAL_TYPE = "charts";
export const VERSION = process.env.VERSION;
export const PRODUCT = "Zebra BI Charts for Office";
